<template>
  <div>
    <input
      type="hidden"
      id="emailList"
      :value="emailsToCopy"
    />
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="copyEmailsToClipboard"
          text
          rounded
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'CopyEmailsToClipboard',
    props: {
      emails: Array
    },
    data () {
      return {
        tooltipText: ''
      }
    },
    created () {
      this.init()
    },
    computed: {
      emailsToCopy () {
        return this.emails.toString()
      }
    },
    methods: {
      init () {
        this.tooltipText = 'Copy emails to clipboard'
      },
      copyEmailsToClipboard () {
        let copyText = document.getElementById('emailList')
        copyText.setAttribute('type', 'text')
        copyText.select()
        try {
          let success = document.execCommand('copy')
          if (success) {
            this.tooltipText = 'Emails copied to clipboard!'
            this.$store.dispatch('setSnackbar', {
              snackbarColor: 'success',
              showSnackbar: true,
              snackbarY: 'top',
              snackbarX: 'right',
              snackbarText: `Emails copied to clipboard!`
            })
            setTimeout(() => {
              this.init()
            }, 6000)
          }
        } catch (err) {
          this.$store.dispatch('setSnackbar', {
            snackbarColor: 'error',
            showSnackbar: true,
            snackbarY: 'top',
            snackbarX: 'right',
            snackbarText: `Unable to copy emails to clipboard!`
          })
        }
        copyText.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      }
    }
  }
</script>
